import {
  Button,
  Stack,
  Typography,
  Link as MuiLink,
  Select,
  MenuItem,
} from '@mui/material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Organization } from 'src/app/api/openapi';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo, useRef, useState } from 'react';
import { OrganizationClient } from 'src/app/api/clients/organizations';
import CustomDataGrid from 'src/app/components/CustomDataGrid';

const Organizations = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [toCreate, setToCreate] = useState(
    searchParams.get('create') || 'products'
  );

  const cursor = useRef<string | undefined>(undefined);

  const dataSource = useMemo(
    () => ({
      getRows: () =>
        OrganizationClient.list('name', 20, cursor.current).then(({ data }) => {
          cursor.current = data.cursor;
          return {
            rows: data?.items || [],
          };
        }),
    }),
    []
  );

  const columns: GridColDef<Organization>[] = [
    {
      headerName: 'Name',
      field: 'name',
      renderCell: ({ row }) => (
        <MuiLink
          component={Link}
          to={`/${toCreate || 'products'}/${row.id}/create`}
          state={row}
        >
          {row.name || row.id}
        </MuiLink>
      ),
      flex: 1,
    },
    {
      headerName: 'ID',
      field: 'id',
      width: 225,
    },
  ];

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h1">Organizations</Typography>
        <Button variant="flat" onClick={() => navigate('./create')}>
          Create Organization
        </Button>
      </Stack>
      <Typography variant="body1" gutterBottom>
        Select an organization to create a product or brand under that
        organization.
      </Typography>
      <Stack direction="row" alignItems="center" my={2}>
        <Typography mr={1}>Create a:</Typography>
        <Select
          label="Create a:"
          value={toCreate}
          onChange={({ target }) => setToCreate(target.value)}
        >
          <MenuItem value="products">Product</MenuItem>
          <MenuItem value="brands">Brand</MenuItem>
        </Select>
      </Stack>
      <Stack maxHeight="80vh">
        <CustomDataGrid
          dataSource={dataSource}
          columns={columns}
          rowCount={-1}
          lazyLoading
          paginationModel={{ page: 0, pageSize: 20 }}
        />
      </Stack>
    </>
  );
};

export default Organizations;
